import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { IHistory} from 'src/app/models/IHistory';
@Component({
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit {
    isLoading:boolean;
    dir:string;
    totalRecords: number;
    histories: IHistory[];
    cols: any[];

    constructor(private helperService:HttphelperService,private cd:ChangeDetectorRef,private messageService: MessageService,private translate: TranslateService) {
      this.isLoading = false;
      this.totalRecords = 0;
      let currentLnaguage =  localStorage.getItem('lang');
      if(currentLnaguage == null){
          this.dir = "ltr"; 
      }
      else
      {
        if(currentLnaguage == 'ar'){
          this.dir = "rtl"; 
        }
        else{
          this.dir = "ltr"; 
        }
      }
    }

    ngOnInit() {
        this.cols = [
            {field: 'Modality', header: 'Clinic'},
            {field: 'ServiceName', header: 'Service Name'},
            {field: 'OrderDateSiteSettingFormat', header: 'OrderDate'},
            {field: 'ProviderName', header: 'ProviderName'},
            {field: 'Status', header: 'Status'},
            {field: 'RequestType', header: 'RequestType'},
            {field: 'Image', header: 'Image'},
            {field: 'Report', header: 'Report'}
        ];
    }
    loadHistoryData(event: LazyLoadEvent)
    {
      let searchWord = event.globalFilter || '';
      let pageIndex = (event.first / event.rows) + 1;
      this.isLoading = true;
      this.cd.detectChanges();
      let patientId = localStorage.getItem('PatientId');
      var historyUrl = `/api/Queue/GetHitoryWithDetails?PageSize=${event.rows}&pageid=${pageIndex}&patId=${patientId}&filter=${searchWord}`;
      this.helperService.getRequest(historyUrl,true).subscribe(response => {
      if(response.Success)
      {
        this.histories = response?.Data?.data;
        if(this.histories != null && this.histories != undefined)
        {
          for(let i=0; i<this.histories.length; i++)
          {
            if(this.histories[i].PatientReports.length > 0)
            {
              this.histories[i].ReportCount = this.histories[i].PatientReports.length;
            }
            else
            {
              this.histories[i].ReportCount = 0;
            }
          }
        }
        else
        {
          this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
        }
        this.totalRecords = response?.AllDataCount;
      }
      else{
        this.messageService.add({severity: 'error', summary: 'Error', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
    },
    error=>{
      this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
      this.isLoading = false;
      this.totalRecords = 0;
    })
  }
  DownloadReport(encruptedVisitId :string){
    var resulturl = `/api/Queue/ShowReport?Result=`+encruptedVisitId+"&type=accountservice";
    this.helperService.getRequest(resulturl,true).subscribe({
      next:resultData => {
        if(resultData.Success){
          window.open(resultData.Message, '_blank');
        }
        else{
          this.messageService.add({severity: 'error', summary: 'Error', detail:resultData.Message, life: 2000});
        }
      },
      error:err => {
        this.messageService.add({severity: 'error', summary: 'Error', detail:err.Message, life: 2000});
      }
    });
  }
}
